const pl = {
  brand: "E2 Care",
  tagline: "Spokojna, połączona opieka.",
  nav_dashboard: "Pulpit",
  nav_residents: "Pacjenci",
  nav_patients: "Pacjenci",
  nav_rooms: "Pokoje",
  nav_devices: "Urządzenia",
  nav_events: "Zdarzenia",
  nav_alerts: "Alerty",
  nav_users: "Zespół",
  nav_settings: "Ustawienia",
  nav_admin: "Administracja",
  nav_signout: "Wyloguj się",
  topbar_search_placeholder: "Szukaj pacjentów, pokoi, urządzeń…",
  admin_super_only: "Tylko superadministratorzy mogą zarządzać organizacjami.",
  admin_admin_only: "Tylko administratorzy mają dostęp do tej strony.",
  admin_tab_orgs: "Organizacje",
  admin_tab_users: "Użytkownicy",
  admin_tab_patients: "Pacjenci",
  admin_tab_rooms: "Pokoje",
  admin_tab_buildings: "Budynki",
  admin_tab_devices: "Urządzenia",
  admin_tab_alerts: "Alerty",
  admin_tab_qa: "Narzędzia testowe",
  admin_delete: "Usuń",
  admin_no_orgs_yet: "Brak organizacji.",
  admin_field_name: "Nazwa",
  admin_field_email: "E-mail",
  admin_field_phone: "Telefon",
  admin_field_password: "Hasło",
  admin_field_role: "Rola",
  admin_field_type: "Typ",
  admin_field_timezone: "Strefa czasowa",
  admin_field_address: "Adres",
  admin_field_status: "Status",
  admin_field_organization: "Organizacja",
  admin_password_keep: "Pozostaw puste, aby zachować obecne",
  admin_field_birth_date: "Data urodzenia",
  admin_field_room: "Pokój",
  admin_field_room_none: "Nieprzypisany",
  admin_field_photo: "URL zdjęcia",
  admin_field_photo_hint: "Wklej publiczny adres URL obrazu — pełne przesyłanie w wersji 2.",
  admin_field_notes: "Notatki opiekuna",
  admin_field_emergency_contact: "Główny kontakt awaryjny",
  admin_field_ec_name: "Imię i nazwisko",
  admin_field_ec_phone: "Telefon",
  admin_field_ec_relationship: "Pokrewieństwo",
  admin_field_mac: "Adres MAC",
  admin_field_firmware: "Oprogramowanie",
  admin_field_assignment: "Przypisane do",
  admin_field_assigned_room: "Przypisany pokój",
  admin_field_assigned_patient: "Przypisany pacjent",
  admin_field_assigned_hint: "Opcjonalne. Czujniki zwykle przypisuje się do pokoju, opaski do pacjenta.",
  admin_field_sensor_target: "Zamontowany na",
  admin_field_sensor_target_hint: "Informuje system, czy ten czujnik obserwuje drzwi czy okno.",
  sensor_target_door: "Drzwi",
  sensor_target_window: "Okno",
  sensor_target_unset: "Nie skonfigurowano",
  admin_field_sensor_label: "Etykieta czujnika",
  admin_field_sensor_label_hint: "Przyjazna nazwa wyświetlana w alertach i zdarzeniach — np. „Drzwi wejściowe”, „Okno łazienki”.",
  admin_field_building: "Budynek",
  admin_field_building_required: "Pokój musi należeć do budynku.",
  room_openings: "Otwory",
  room_no_openings: "W tym pokoju nie zainstalowano jeszcze czujników drzwi ani okien.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Ostatnia zmiana",
  admin_field_description: "Opis",
  admin_field_severity: "Ważność",
  admin_field_patient: "Pacjent",
  admin_field_device: "Urządzenie",
  admin_field_message: "Wiadomość",
  admin_orgs_title: "Organizacje",
  admin_orgs_sub: "Twórz, edytuj i archiwizuj najemców E2 Care.",
  admin_orgs_count: "organizacje",
  admin_org_new: "Nowa organizacja",
  admin_org_new_title: "Nowa organizacja",
  admin_org_edit_title: "Edytuj organizację",
  admin_org_created: "Utworzono organizację.",
  admin_org_updated: "Zaktualizowano organizację.",
  admin_org_deleted: "Zarchiwizowano organizację.",
  admin_org_delete_title: "Zarchiwizować organizację?",
  admin_org_delete_confirm: "To ukryje „{name}” na listach. W razie potrzeby można ją przywrócić z bazy danych.",
  admin_users_title: "Użytkownicy",
  admin_users_sub_super: "Zarządzaj wszystkimi kontami użytkowników u wszystkich najemców.",
  admin_users_sub_org: "Zarządzaj kontami użytkowników dla {org}.",
  admin_user_new: "Nowy użytkownik",
  admin_user_new_title: "Nowy użytkownik",
  admin_user_edit_title: "Edytuj użytkownika",
  admin_user_created: "Utworzono użytkownika.",
  admin_user_updated: "Zaktualizowano użytkownika.",
  admin_user_deleted: "Zarchiwizowano użytkownika.",
  admin_user_delete_title: "Zarchiwizować użytkownika?",
  admin_user_delete_confirm: "„{name}” utraci dostęp. Aktywne sesje nie są zamykane.",
  admin_user_memberships: "Członkostwa w organizacjach",
  admin_patients_title: "Pacjenci",
  admin_patients_sub_super: "Zarządzaj wszystkimi kartami pacjentów u wszystkich najemców.",
  admin_patients_sub_org: "Zarządzaj kartami pacjentów w {org}.",
  admin_patient_new: "Nowy pacjent",
  admin_patient_new_title: "Nowy pacjent",
  admin_patient_edit_title: "Edytuj pacjenta",
  admin_patient_created: "Utworzono pacjenta.",
  admin_patient_updated: "Zaktualizowano pacjenta.",
  admin_patient_deleted: "Zarchiwizowano pacjenta.",
  admin_patient_delete_title: "Zarchiwizować pacjenta?",
  admin_patient_delete_confirm: "„{name}” zostanie ukryty na listach. Powiązania z zespołem opieki i rodziną są zachowane.",
  admin_rooms_title: "Pokoje",
  admin_rooms_sub_super: "Konfiguruj pokoje u wszystkich najemców.",
  admin_rooms_sub_org: "Konfiguruj pokoje w {org}.",
  admin_room_new: "Nowy pokój",
  admin_room_new_title: "Nowy pokój",
  admin_room_edit_title: "Edytuj pokój",
  admin_room_created: "Utworzono pokój.",
  admin_room_updated: "Zaktualizowano pokój.",
  admin_room_deleted: "Zarchiwizowano pokój.",
  admin_room_delete_title: "Zarchiwizować pokój?",
  admin_room_delete_confirm: "„{name}” zostanie ukryty. Istniejący pacjenci zachowują odniesienie assigned_room_id.",
  admin_devices_title: "Urządzenia",
  admin_devices_sub_super: "Udostępniaj urządzenia Moko u wszystkich najemców.",
  admin_devices_sub_org: "Udostępniaj urządzenia Moko w {org}.",
  admin_device_new: "Nowe urządzenie",
  admin_device_new_title: "Nowe urządzenie",
  admin_device_edit_title: "Edytuj urządzenie",
  admin_device_created: "Utworzono urządzenie.",
  admin_device_updated: "Zaktualizowano urządzenie.",
  admin_device_deleted: "Zarchiwizowano urządzenie.",
  admin_device_delete_title: "Zarchiwizować urządzenie?",
  admin_device_delete_confirm: "Urządzenie {mac} zostanie ukryte. Wcześniejsze zdarzenia i alerty pozostają w historii.",
  admin_buildings_title: "Budynki",
  admin_buildings_sub_super: "Grupuj pokoje według fizycznego budynku / skrzydła u wszystkich najemców.",
  admin_buildings_sub_org: "Grupuj pokoje według fizycznego budynku / skrzydła w {org}.",
  admin_building_new: "Nowy budynek",
  admin_building_new_title: "Nowy budynek",
  admin_building_edit_title: "Edytuj budynek",
  admin_building_created: "Utworzono budynek.",
  admin_building_updated: "Zaktualizowano budynek.",
  admin_building_deleted: "Zarchiwizowano budynek.",
  admin_building_delete_title: "Zarchiwizować budynek?",
  admin_building_delete_confirm: "„{name}” zostanie ukryty. Pokoje zachowują odniesienie corpus_id.",
  admin_qa_title: "Narzędzia testowe",
  admin_qa_sub: "Wstrzykuj zdarzenia / alerty, aby przetestować pulpit, wysyłkę alertów i kanały powiadomień bez używania prawdziwych urządzeń Moko.",
  admin_qa_event_title: "Wstrzyknij zdarzenie testowe",
  admin_qa_event_sub: "Symuluje webhook urządzenia Moko. Backend uruchomi swój potok wysyłki alertów, tak jakby zdarzenie pochodziło z prawdziwego sprzętu.",
  admin_qa_alert_title: "Wstrzyknij alert testowy",
  admin_qa_alert_sub: "Pomija warstwę zdarzeń i zapisuje alert bezpośrednio. Użyj do testowania dzwonka, listy oraz wysyłki Slack/Telegram.",
  admin_qa_inject_event: "Wstrzyknij zdarzenie",
  admin_qa_inject_alert: "Wstrzyknij alert",
  admin_qa_event_done: "Wstrzyknięto zdarzenie. Obserwuj stronę Zdarzenia i pulpit.",
  admin_qa_alert_done: "Wstrzyknięto alert. Obserwuj dzwonek.",
  admin_qa_disclaimer: "Te punkty końcowe należy wyłączyć lub oflagować w środowisku produkcyjnym.",
  admin_alerts_title: "Polityka alertów",
  admin_alerts_sub: "Reguły alertów obowiązujące w całej {org}. Stosowane do każdego pacjenta tego najemcy.",
  admin_alerts_quiet_title: "Godziny ciszy",
  admin_alerts_quiet_desc: "Określ, kiedy ta organizacja jest w „trybie nocnym”. Przydatne do dyskretniejszego kierowania alertów niekrytycznych.",
  admin_alerts_quiet_hint: "Godziny są interpretowane w lokalnej strefie czasowej organizacji. Zakres może przekraczać północ (np. 22:00 → 06:00).",
  admin_alerts_night_start: "Początek nocy",
  admin_alerts_night_end: "Koniec nocy",
  admin_alerts_load_failed: "Wczytaj politykę alertów",
  admin_alerts_save_failed: "Zapisz politykę alertów",
  admin_alerts_saved: "Zapisano politykę alertów.",
  admin_alerts_clear_title: "Wyczyść aktywne alerty",
  admin_alerts_clear_desc: "Potwierdź jednym kliknięciem wszystkie otwarte alerty w tej organizacji.",
  admin_alerts_clear_hint: "Przydatne po zaplanowanym ćwiczeniu lub źle skonfigurowanym czujniku, który wywołał falę fałszywych alarmów. Potwierdzone alerty pozostają w historii.",
  admin_alerts_ack_all_button: "Potwierdź wszystkie",
  admin_alerts_ack_all_title: "Potwierdzić wszystkie aktywne alerty?",
  admin_alerts_ack_all_confirm: "To oznaczy jako potwierdzony każdy otwarty alert w {org}. Tej akcji nie można cofnąć.",
  admin_alerts_ack_all_done: "Potwierdzono {count} alert(ów).",
  admin_alerts_ack_all_done_generic: "Potwierdzono wszystkie aktywne alerty.",
  admin_alerts_ack_all_failed: "Potwierdź wszystkie alerty",
  org_type_nursing_home: "Dom opieki",
  org_type_assisted_living: "Mieszkanie wspomagane",
  org_type_hospital: "Szpital",
  org_type_home_care: "Opieka domowa",
  role_admin: "Administrator",
  role_caregiver: "Opiekun",
  role_family: "Rodzina",
  status_active: "aktywny",
  status_inactive: "nieaktywny",
  confirm: "Potwierdź",
  sign_in: "Zaloguj się",
  signed_in: "Zalogowano",
  sign_up: "Zarejestruj się",
  email: "E-mail",
  password: "Hasło",
  full_name: "Imię i nazwisko",
  create_account: "Utwórz konto",
  no_account: "Nie masz jeszcze konta?",
  have_account: "Masz już konto?",
  login_welcome: "Witaj ponownie",
  login_sub: "Zaloguj się, aby kontynuować monitorowanie swoich podopiecznych.",
  register_welcome: "Dołącz do E2 Care",
  register_sub: "Utwórz swoją przestrzeń opiekuna w niecałą minutę.",
  total_residents: "Pacjenci",
  active_devices: "Aktywne urządzenia",
  open_alerts: "Otwarte alerty",
  offline_gateways: "Urządzenia offline",
  falls_7d: "Upadki (7 dni)",
  sos_7d: "SOS (7 dni)",
  low_battery: "Niski poziom baterii",
  critical_residents: "Krytyczni",
  status_ok: "Wszystko w porządku",
  status_warning: "Uwaga",
  status_critical: "Krytyczny",
  status_online: "Online",
  status_offline: "Offline",
  search: "Szukaj",
  filter: "Filtruj",
  all: "Wszystkie",
  refresh: "Odśwież",
  loading: "Ładowanie…",
  no_results: "Jeszcze nic tu nie ma.",
  view_profile: "Zobacz profil",
  showing_n_of_m: "Wyświetlanie {n} z {m}",
  load_more: "Wczytaj więcej",
  auto_refresh: "Na żywo · autoodświeżanie",
  auto_refresh_paused: "Wstrzymano (aktywne wczytywanie więcej)",
  updated_just_now: "Zaktualizowano przed chwilą",
  updated_n_sec_ago: "Zaktualizowano {n} s temu",
  updated_n_min_ago: "Zaktualizowano {n} min temu",
  acknowledge: "Potwierdź",
  acknowledged: "Potwierdzono",
  ack_all: "Potwierdź wszystkie",
  ack_all_confirm: "Potwierdzić wszystkie {count} aktywne alerty?",
  ack_all_running: "Potwierdzanie…",
  ack_all_done: "Potwierdzono {count} alert(ów).",
  ack_all_partial: "{ok} potwierdzono · {fail} nie powiodło się.",
  last_seen: "Ostatnio widziano",
  battery: "Bateria",
  signal: "Sygnał",
  firmware: "Oprogramowanie",
  room: "Mieszk. / Pokój",
  age: "Wiek",
  emergency_contact: "Kontakt awaryjny",
  notes: "Notatki",
  assigned_devices: "Przypisane urządzenia",
  recent_events: "Ostatnie zdarzenia",
  timeline_24h: "Ostatnie 24 godziny",
  delivery_status: "Status dostarczenia",
  acknowledged_by: "Potwierdzone przez",
  dashboard_title: "Przegląd domu",
  dashboard_sub: "Szybki obraz wszystkiego, co dzieje się w domach, którymi się opiekujesz.",
  residents_title: "Pacjenci",
  residents_sub: "Osoby, które teraz monitorujesz.",
  devices_title: "Urządzenia",
  devices_sub: "Czujniki i tagi.",
  devices_sub_admin: "Bramki, czujniki i tagi.",
  events_title: "Zdarzenia na żywo",
  events_sub: "Chronologiczny strumień z każdego podłączonego urządzenia.",
  alerts_title: "Alerty",
  alerts_sub: "Powiadomienia eskalowane do rodziny i opiekunów.",
  settings_title: "Ustawienia",
  settings_sub: "Twoje preferencje i reguły powiadomień.",
  users_title: "Zespół",
  users_sub: "Opiekunowie, rodzina i administratorzy z dostępem.",
  falls_chart_title: "Upadki i SOS — ostatnie 7 dni",
  recent_alerts_title: "Ostatnie krytyczne alerty",
  no_alerts: "Brak otwartych alertów. Wszyscy są bezpieczni.",
  event_fall: "Wykryto upadek",
  event_sos: "Naciśnięto przycisk SOS",
  event_door_open: "Otwarto drzwi",
  event_door_close: "Zamknięto drzwi",
  event_inactivity: "Przedłużona bezczynność",
  event_low_battery: "Niski poziom baterii",
  event_offline: "Urządzenie offline",
  event_online: "Urządzenie znów online",
  event_heartbeat: "Sygnał kontrolny",
  event_button_press: "Naciśnięto przycisk",
  device_gateway: "Bramka Bluetooth",
  device_door_sensor: "Czujnik drzwi",
  device_bracelet: "Opaska",
  device_unknown: "Nieznane urządzenie",
  language: "Język",
  notifications: "Powiadomienia",
  quiet_hours: "Godziny ciszy",
  escalation: "Polityka eskalacji",
  just_now: "przed chwilą",
  rel_prefix: "",
  min_ago: "min temu",
  h_ago: "godz. temu",
  d_ago: "dni temu",
  demo_hint: "Konto demo: admin@e2care.lv / Care2024!",
  open_menu: "Otwórz menu",
  close_menu: "Zamknij menu",
  care_team: "Zespół opieki",
  family_members: "Rodzina",
  no_caregivers: "Nie przypisano jeszcze opiekunów.",
  no_family: "Nie połączono jeszcze członków rodziny.",
  add_caregiver: "Dodaj opiekuna",
  add_family: "Dodaj członka rodziny",
  select_user: "Wybierz użytkownika…",
  cancel: "Anuluj",
  add: "Dodaj",
  remove: "Usuń",
  save: "Zapisz",
  relationship: "Pokrewieństwo",
  relationship_son: "Syn",
  relationship_daughter: "Córka",
  relationship_spouse: "Małżonek",
  relationship_other: "Inne",
  notify_via: "Powiadom przez",
  call_contact: "Zadzwoń do kontaktu",
  view_resident: "Otwórz profil",
  address: "Adres",
  admin_only_section: "Narzędzia administratora",
  rooms_title: "Pokoje",
  rooms_sub: "Każdy nadzorowany pokój — pacjenci, urządzenia i bieżący stan.",
  room_name: "Pokój",
  room_type: "Typ",
  room_type_private_room: "Pokój prywatny",
  room_type_shared_room: "Pokój wspólny",
  room_type_apartment: "Mieszkanie",
  room_type_corridor: "Korytarz",
  room_type_common_area: "Część wspólna",
  room_floor: "Piętro",
  room_state: "Bieżący stan",
  door: "Drzwi",
  window: "Okno",
  door_open_state: "Otwarte",
  door_closed_state: "Zamknięte",
  door_unknown_state: "Nieznany",
  room_no_devices: "W tym pokoju nie ma jeszcze urządzeń.",
  room_no_patients: "Do tego pokoju nie przypisano jeszcze pacjentów.",
  room_patients: "Pacjenci w pokoju",
  room_devices: "Urządzenia w pokoju",
  room_activity: "Oś czasu aktywności",
  rooms_filter_all_types: "Wszystkie typy",
  widget_active_alerts: "Aktywne alerty",
  widget_active_alerts_sub: "Krytyczne, nierozwiązane i potwierdzone",
  widget_patients_status: "Status pacjentów",
  widget_devices_health: "Stan urządzeń",
  widget_room_activity: "Aktywność pokoi",
  widget_recent_events: "Strumień zdarzeń na żywo",
  widget_connectivity: "Łączność",
  metric_critical: "Krytyczne",
  metric_unresolved: "Nierozwiązane",
  metric_acknowledged_count: "Potwierdzone",
  metric_total: "Łącznie",
  metric_active: "Aktywne",
  metric_online: "Online",
  metric_offline: "Offline",
  metric_ota_pending: "Oczekujące OTA",
  metric_battery_warn: "Niska bateria",
  metric_doors_open: "Otwarte drzwi",
  metric_windows_open: "Otwarte okna",
  metric_signal_avg: "Śr. sygnał",
  metric_last_comm: "Ostatnia komunikacja",
  metric_packets: "Pakiety / godz.",
  view_all: "Zobacz wszystkie",
  status_new: "Nowy",
  status_acknowledged: "Potwierdzony",
  status_resolved: "Rozwiązany",
  status_resolved_local: "Rozwiązany (lokalnie)",
  resolve: "Rozwiąż",
  add_note: "Dodaj notatkę",
  save_note: "Zapisz notatkę",
  resolve_local_badge: "tylko to urządzenie",
  resolve_local_hint: "Oznacza alert jako rozwiązany tylko w Twojej przeglądarce. Serwer i inni członkowie zespołu nadal widzą go jako otwarty.",
  note_placeholder: "Dodaj kontekst dla zespołu…",
  notes_count: "{n} notatka(-i)",
  device_detail: "Szczegóły urządzenia",
  device_diagnostics: "Diagnostyka",
  device_firmware_history: "Historia oprogramowania",
  device_ota_config: "Konfiguracja OTA",
  device_ota_status: "Status OTA",
  device_signal: "Jakość sygnału",
  device_mac: "Adres MAC",
  device_serial: "Numer seryjny",
  fall_sensitivity: "Czułość wykrywania upadku",
  transmission_interval: "Interwał transmisji",
  low_battery_threshold: "Próg niskiej baterii",
  ota_idle: "Bezczynny",
  ota_pending: "Oczekujący",
  ota_deploying: "Wdrażanie",
  ota_failed: "Niepowodzenie",
  events_filter_severity: "Ważność",
  events_filter_room: "Pokój",
  events_filter_patient: "Pacjent",
  events_filter_device: "Urządzenie",
  severity_info: "Informacja",
  severity_warning: "Ostrzeżenie",
  severity_critical: "Krytyczny",
  telegram_title: "Alerty Telegram",
  telegram_desc: "Otrzymuj alerty na Telegramie dla przypisanych podopiecznych.",
  telegram_connect: "Połącz Telegram",
  telegram_connected: "Telegram połączony",
  telegram_connected_as: "Połączono z Telegramem jako {name}",
  telegram_connect_success: "Pomyślnie połączono Telegram",
  telegram_connect_error: "Nie udało się połączyć Telegrama. Spróbuj ponownie.",
  telegram_missing_bot: "Bot Telegram nie jest skonfigurowany. Ustaw REACT_APP_TELEGRAM_BOT w pliku env.",
  telegram_disconnect: "Rozłącz",
  telegram_disconnect_success: "Rozłączono Telegram.",
  telegram_disconnect_error: "Nie udało się rozłączyć Telegrama. Spróbuj ponownie.",
  telegram_already_linked: "To konto Telegram jest już powiązane z innym użytkownikiem e2-care.",
  telegram_switch_q: "Użyć innego konta Telegram?",
  telegram_switch_intro: "Telegram pamięta, które konto jest zalogowane na wszystkich stronach. Aby użyć innego:",
  telegram_switch_step1: "Otwórz Telegram Web i wyloguj się z bieżącego konta.",
  telegram_switch_step2: "Wróć tutaj i przeładuj poniższy przycisk, a następnie zaloguj się drugim kontem.",
  telegram_open_web: "Otwórz Telegram Web",
  telegram_reload_widget: "Wylogowałem się — przeładuj przycisk",
  lang_autodetected_toast: "Wykryto Twój język jako {language}. Możesz go zmienić w Ustawieniach.",
  admin_view_active: "Aktywne",
  admin_view_archived: "Zarchiwizowane",
  admin_restore: "Przywróć",
  admin_restored: "Przywrócono.",
  admin_hard_delete: "Usuń trwale",
  admin_hard_delete_title: "Usunąć trwale?",
  admin_hard_delete_confirm: "To trwale usunie „{name}” z bazy danych. Tej akcji nie można cofnąć.",
  admin_hard_deleted: "Trwale usunięto.",
  admin_no_archived: "Brak zarchiwizowanych elementów.",
  language_desc: "Używany do interfejsu aplikacji oraz powiadomień Telegram + push.",
  language_saved: "Zaktualizowano język.",
  language_error: "Nie udało się zaktualizować języka. Spróbuj ponownie.",
  admin_field_language: "Język",
  edit: "Edytuj",
  generic_error: "Coś poszło nie tak. Spróbuj ponownie.",
  caregiver_added: "Dodano opiekuna.",
  caregiver_removed: "Usunięto opiekuna.",
  family_added: "Dodano członka rodziny.",
  family_removed: "Usunięto członka rodziny.",
  menu: "Menu",
  dl_companion_app: "Aplikacja towarzysząca",
  dl_hero_title: "E2 Care na Androida",
  dl_hero_sub: "Zainstaluj aplikację towarzyszącą na telefonie z Moko, aby przekazywać alerty, konfigurować urządzenia i pozostać w kontakcie z zespołem opieki — nawet gdy pulpit jest zamknięty.",
  dl_android_apk: "APK Android",
  dl_version_loading: "ładowanie wersji…",
  dl_released: "Wydano {date}",
  dl_download_apk: "Pobierz APK",
  dl_unavailable: "Niedostępne",
  dl_preparing: "Przygotowywanie…",
  dl_manifest_error: "Nie udało się wczytać manifestu. Spróbuj odświeżyć — jeśli problem nie ustępuje, serwer kompilacji może być ponownie wdrażany.",
  dl_whats_new: "Co nowego",
  dl_installing_title: "Instalacja na telefonie",
  dl_step1: "Naciśnij „Pobierz APK” powyżej. Przeglądarka może ostrzec, że pliki APK mogą uszkodzić urządzenie — to ostrzeżenie jest normalne dla każdego instalatora pobranego poza Sklepem Play.",
  dl_step2: "Otwórz pobrany plik. Android poprosi o zezwolenie na instalacje z tej przeglądarki za pierwszym razem — włącz uprawnienie i wróć.",
  dl_step3: "Naciśnij „Zainstaluj”, a następnie „Otwórz” po zakończeniu.",
  dl_step4: "Zaloguj się przy użyciu swoich danych E2 Care.",
  dl_iphone_note: "Wersja na iPhone pojawi się później. Na razie skorzystaj z pulpitu internetowego.",
  dl_back_to_dashboard: "Powrót do pulpitu",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Zmiana organizacji usuwa bieżące przypisanie pokoju i pacjenta.",
  admin_view_full: "Pełna lista",
  device_filter_assignment: "Przypisanie",
  device_filter_patient: "Przypisany do pacjenta",
  device_filter_room: "Przypisany do pokoju",
  device_filter_unassigned: "Nieprzypisany",
  admin_all_orgs: "Wszystkie organizacje",
  pagination_prev: "Poprzednia",
  pagination_next: "Następna",
  pagination_per_page: "Na stronę",
  pagination_page_of: "Strona {page} z {pages}",
  pagination_total: "Łącznie {total}",
  event_charging: "Rozpoczęto ładowanie",
  event_sos_cancel: "SOS anulowane",
  event_call: "Połączenie SOS",
  device_personal_alarm: "Alarm osobisty",
  device_charging: "Ładowanie",
  device_location: "Lokalizacja",
  device_current_location: "Bieżąca lokalizacja",
  device_no_location: "Brak zgłoszonej lokalizacji.",
  device_location_source: "Źródło",
  device_location_updated: "Zaktualizowano",
  device_track_1h: "1 godz.",
  device_track_24h: "24 godz.",
  device_track_7d: "7 dni",
  device_track_last: "Ostatnia pozycja",
  device_located: "Zlokalizowano",
  map_sos: "Alarm SOS",
  map_fall: "Wykryto upadek",
  map_current: "Bieżąca pozycja",
  alert_timeline: "Oś czasu alarmu",
  alert_trigger: "Wyzwalacz",
  alert_calls: "Połączenia",
  alert_view_timeline: "Zobacz oś czasu",
  alert_no_deliveries: "Nie wysłano jeszcze powiadomień.",
  alert_cancelled_on_device: "SOS zostało anulowane na urządzeniu — alarm pozostaje otwarty, dopóki opiekun go nie rozwiąże.",
  call_answered: "Odebrane",
  call_missed: "Nieodebrane",
  reopen: "Otwórz ponownie",
  reopened: "Alarm otwarty ponownie",
  live: "Na żywo",
  nav_home: "Start",
  family_home_kicker: "Widok rodziny",
  family_home_title: "Twoi bliscy",
  family_greeting: "Cześć",
  family_home_sub: "Spokojny przegląd tego, jak się wszyscy mają.",
  family_status_ok: "czuje się dobrze",
  family_status_attention: "wymaga uwagi",
  family_all_calm: "Na razie wszystko spokojnie.",
  family_attention_sub: "Sprawdźmy, co u niego — szczegóły poniżej.",
  family_last_seen: "ostatnio widziany",
  family_latest_alert: "Ostatni alarm",
  family_no_alerts: "Brak ostatnich alarmów — wszystko w porządku.",
  family_view_details: "Zobacz szczegóły",
  family_no_device: "Brak powiązanego alarmu osobistego.",
  status_never_reported: "Nigdy nie raportował",
  mv_title: "Ruch",
  mv_sub: "Z {n} czujnika(-ów) ruchu · okna 5-minutowe",
  mvo_title: "Ruch w skrócie",
  mvs_moving: "{name} jest na nogach",
  mvs_moving_sub: "Ruch {when}",
  mvs_rest: "{name} odpoczywa",
  mvs_rest_sub: "Ostatni ruch {when}",
  mvs_rest_sub_none: "Brak ruchu w ostatnich 30 dniach",
  mvs_quiet: "{name} nie rusza się dłużej niż zwykle",
  mvs_quiet_sub: "Brak ruchu od {dur}. Może warto zadzwonić.",
  mvs_short_quiet: "Długo bez ruchu",
  mvs_room_moving: "Ktoś się porusza w {name}",
  mvs_room_rest: "W {name} jest spokojnie",
  mvs_room_quiet: "Brak ruchu w {name} dłużej niż zwykle",
  mvs_sensor: "Czujnik ruchu nie przesyła danych",
  mvs_sensor_sub: "To dotyczy czujnika, nie osoby {name}. Ostatni sygnał {when}.",
  mvs_nodata: "Brak danych o ruchu",
  mvs_nodata_sub: "Czujnik ruchu jeszcze niczego nie przesłał.",
  mvd_title: "Ostatnie 24 godziny",
  mvd_moving: "Ruch",
  mvd_resting: "Odpoczynek",
  mvd_nosignal: "Brak sygnału",
  mvd_night: "Noc",
  mvd_now: "Teraz",
  mvn_title: "Ostatnie 7 nocy",
  mvn_last_night: "Ostatnia noc",
  mvn_last_short: "Wczoraj",
  mvn_calm: "Spokojna",
  mvn_restless: "Niespokojna",
  mvn_still: "Bardzo spokojna",
  mvn_silent: "Czujnik milczał",
  mvn_nodata: "Brak danych",
  mvn_s_calm_none: "Spokojna noc, brak ruchu między {from} a {to}.",
  mvn_s_calm_once: "Spokojna noc, jedna pobudka około {at}.",
  mvn_s_calm_many: "Spokojna noc, pobudki: {n}, pierwsza około {first}, ostatnia około {last}.",
  mvn_s_restless: "Niespokojna noc, pobudki: {n} między {first} a {last}.",
  mvn_s_still: "Bardzo spokojna noc, mniej ruchu niż zwykle. Najdłuższy odpoczynek {dur}.",
  mvn_s_still_moved: "Bardzo spokojna noc, ruch tylko około {at}. Najdłuższy odpoczynek {dur}.",
  mvn_s_silent: "Czujnik prawie milczał, więc nie wiemy, jak minęła noc.",
  mvn_s_nodata: "Brak danych o ruchu dla tej nocy.",
  mv_state_moving: "Ruch",
  mv_state_still: "Odpoczynek",
  mv_state_inactive: "Nieaktywny",
  mv_state_silent: "Czujnik nie raportuje",
  mv_state_never: "Nigdy nie raportował",
  mv_state_nodata: "Brak danych",
  mv_state_no_sensor: "Brak czujnika ruchu",
  mv_last_movement: "Ostatni ruch",
  mv_last_sample: "Ostatni sygnał czujnika",
  mv_none_in_retention: "Brak w ostatnich 30 dniach",
  mv_silent_hint: "Brak próbek od ponad {min} min — sprawdź czujnik lub jego bramkę. To awaria urządzenia, a nie bezruch.",
  mv_inactive_hint: "Brak ruchu od ponad {min} min, choć czujnik nadal raportuje.",
  mv_history: "Historia ruchu",
  mv_history_empty: "Brak danych o ruchu w tym okresie.",
  mv_not_reporting: "Nie raportuje",
  mv_no_movement: "Brak ruchu",
  mv_detections: "wykryć ruchu",
  mv_legend_motion: "Wykrycia ruchu",
  mv_legend_gap: "Nie raportuje",
  mv_retention_note: "Historia przechowywana 30 dni",
  mv_strip_title: "Ruch na żywo",
  mv_strip_sub: "{n} czujnik(i) ruchu",
  mv_unassigned: "Nieprzypisany czujnik",
  admin_alerts_timezone: "Strefa czasowa organizacji",
  admin_alerts_timezone_invalid: "Wybierz prawidłową strefę czasową IANA.",
  admin_alerts_night_wrap_hint: "Godziny nocne trwają od {start} do {end} następnego ranka ({tz}), czyli po {start} lub przed {end}.",
  admin_alerts_night_same_day_hint: "Godziny nocne trwają od {start} do {end} tego samego dnia ({tz}).",
  admin_alerts_night_equal: "Początek i koniec nie mogą być takie same.",
  admin_alerts_inactivity_label: "Próg bezczynności",
  admin_alerts_inactivity_question: "Czy ta osoba się poruszyła? Minuty bez ruchu, po których sytuacja staje się powodem do alertu.",
  admin_alerts_silence_label: "Próg ciszy urządzenia",
  admin_alerts_silence_question: "Czy ten czujnik nadal się komunikuje? Minuty bez żadnej próbki, po których uznaje się to za awarię urządzenia, a nie nieaktywnego mieszkańca.",
  admin_alerts_minutes: "minut",
  admin_alerts_threshold_invalid: "Wpisz liczbę całkowitą większą od 0.",
  admin_alerts_thresholds_provisional: "Wartości początkowe (180 / 30 min) nie zostały jeszcze dostrojone — dostosuj je do swoich mieszkańców.",
  admin_tab_gateways: "Bramki",
  gw_title: "Bramki",
  gw_status_deactivated: "Dezaktywowana",
  gw_scope_pending: "Bramki Twojej organizacji pojawią się tutaj po wdrożeniu aktualizacji backendu.",
  gw_none_for_org: "Do tej organizacji nie przypisano jeszcze żadnej bramki.",
  gw_col_room: "Pokój",
  gw_unassigned: "Nieprzypisana",
  gw_never: "Nigdy",
  gw_edit_title: "Edytuj bramkę",
  gw_new_title: "Nowa bramka",
  gw_super_field: "Tylko superadministrator może to zmienić",
  gw_mac_invalid: "Wpisz 12 znaków szesnastkowych, np. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Typ sprzętu",
  gw_notes: "Notatki",
  gw_manage_sub: "Huby BLE przekazujące dane czujników: stan, organizacja i pokój. Milcząca bramka sprawia, że milkną wszystkie czujniki za nią.",
  gw_filter_all: "Wszystkie organizacje",
  gw_new: "Nowa bramka",
  gw_col_assignment: "Organizacja · Pokój",
  gw_backend_pending: "Wymaga to aktualizacji backendu, która nie jest jeszcze wdrożona.",
  gw_save_failed: "Zapisz bramkę",
  gw_created: "Bramka utworzona",
  gw_saved: "Bramka zapisana",
  gw_reactivated: "Bramka ponownie aktywna",
  gw_deactivated: "Bramka dezaktywowana",
  gw_reactivate: "Aktywuj ponownie",
  gw_deactivate: "Dezaktywuj",
  gw_reactivate_title: "Aktywować ponownie {name}?",
  gw_deactivate_title: "Dezaktywować {name}?",
  gw_reactivate_desc: "Znów będzie liczona w stanie i alertach.",
  gw_deactivate_desc: "Przestaje być liczona w stanie i alertach. Historia zostaje i możesz ją w każdej chwili aktywować ponownie.",
  gw_heard_title: "Słyszane urządzenia",
  gw_heard_sub: "Czujniki przekazane przez tę bramkę w ciągu ostatnich 24 godzin.",
  gw_heard_none: "Brak urządzeń w ciągu ostatnich 24 godzin.",
  gw_heard_unknown: "Nieznane urządzenia",
  gw_msgs_short: "wiad.",
  gw_avg: "śr.",
  gw_samples_short: "próbki",
  gw_not_found: "Bramka nie istnieje lub nie jest dla Ciebie widoczna.",
  gw_one: "Bramka",
  gw_manage_link: "Zarządzaj w Administracji",
  gw_rssi_range: "Zakres sygnału",
  gw_longest_gap: "Najdłuższa przerwa",
  gw_config_push: "Ostatnie wysłanie konfiguracji",
  gw_sub: "Huby BLE przekazujące dane z czujników. Tylko do odczytu — milcząca bramka sprawia, że wszystkie czujniki za nią wyglądają na milczące.",
  gw_super_only: "Stan bramek jest dostępny tylko dla superadministratorów.",
  gw_load_failed: "Wczytywanie bramek",
  gw_status_reporting: "Raportuje",
  gw_status_silent: "Milczy",
  gw_status_never_seen: "Nigdy niewidziana",
  gw_returned: "Wróciła po {h} h przerwy (zakończona {at})",
  gw_count_reporting: "{n} raportuje",
  gw_count_silent: "{n} milczy",
  gw_count_never: "{n} nigdy niewidzianych",
  gw_count_deactivated: "dezaktywowane: {n}",
  gw_window: "Nieaktualna po {h} h bez wiadomości",
  gw_col_name: "Bramka",
  gw_col_status: "Stan",
  gw_col_msgs: "Wiadomości 24 h",
  gw_col_discard: "Odrzucone",
  gw_last_message: "Ostatnia wiadomość",
  gw_devices_seen: "Widziane urządzenia",
  gw_hours_active: "Aktywne godziny",
  gw_unregistered_title: "Raportuje bez wpisu w rejestrze",
  gw_unregistered_desc: "Te identyfikatory występują w aktywności bramek, ale nie mają wpisu (np. urządzenie raportujące pod numerem IMEI). Sumy z obu źródeł mogą się zasadnie różnić.",
  nav_reports: "Raporty",
  rep_night_title: "Podsumowanie nocy",
  rep_night_desc: "Poranne podsumowanie ruchu każdego mieszkańca w godzinach nocnych organizacji oraz okresów ciszy czujników.",
  rep_last_night: "Ostatnia noc",
  rep_nights_ago: "{n} nocy temu",
  rep_policy_fallback: "domyślne godziny nocne (polityka niedostępna)",
  rep_movement: "Ruch",
  rep_windows: "{n} aktywnych okien 5 min",
  rep_no_movement: "Brak ruchu",
  rep_first_movement: "Pierwszy ruch",
  rep_longest_still: "Najdłuższy bezruch",
  rep_silences: "Cisza czujnika",
  rep_none: "Brak",
  rep_coverage: "{pct}% odebrano",
  rep_night_note: "Godziny podano w strefie czasowej organizacji. Bezruch liczony jest tylko, gdy czujnik raportuje; okresy ciszy osiągające próg ciszy są wymienione osobno.",
  dh_reporting_title: "Stan raportowania",
  dh_never_reported_desc: "Zarejestrowane, ale nigdy nie raportowało. To niedokończona instalacja, a nie urządzenie offline.",
  dh_interval_still: "Zmierzony interwał (w spoczynku)",
  dh_interval_moving: "Zmierzony interwał (w ruchu)",
  dh_interval_samples: "Próbki pomiarowe",
  dh_interval_unmeasured: "Brak zmierzonego interwału — obowiązuje próg ciszy organizacji.",
  dh_interval_note: "Interwały są mierzone na podstawie odebranych wiadomości, a nie skonfigurowanej wartości.",
  rep_dur_h_min: "{h} godz. {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Wspólny pokój — może obejmować ruch innych osób",
  rep_no_data_night: "Brak danych dla tej nocy — czujnik nie raportował (lub nie był jeszcze zainstalowany).",
  nav_buildings: "Budynki",
  imei_label: "IMEI",
  imei_hint: "15 cyfr, nadrukowanych z tyłu urządzenia",
  imei_length: "IMEI ma 15 cyfr",
  imei_invalid: "Ten IMEI jest nieprawidłowy. Sprawdź cyfry",
  imei_resident_note: "Alarm towarzyszy mieszkańcowi, więc nie jest przypisany do pokoju.",
  imei_online_hint: "Urządzenie pojawia się online po pierwszym sygnale życia, około 5 minut po włączeniu.",
  forgot_link: "Nie pamiętasz hasła? Kliknij tutaj",
  forgot_title: "Zresetuj hasło",
  forgot_sub: "Podaj swój e-mail, a wyślemy link do zresetowania hasła.",
  forgot_submit: "Wyślij link",
  forgot_sent: "Jeśli istnieje konto dla tego adresu, wysłaliśmy link do zresetowania hasła. Sprawdź skrzynkę.",
  forgot_back: "← Powrót do logowania",
  reset_title: "Ustaw nowe hasło",
  reset_sub: "Wybierz nowe hasło do konta.",
  reset_new_password: "Nowe hasło",
  reset_confirm_password: "Potwierdź hasło",
  reset_hint: "Co najmniej 8 znaków.",
  reset_submit: "Zmień hasło",
  reset_success: "Hasło zostało zmienione. Przekierowanie do logowania…",
  reset_too_short: "Hasło musi mieć co najmniej 8 znaków.",
  reset_mismatch: "Hasła nie są zgodne.",
  reset_no_token: "Ten link jest nieprawidłowy lub go brak. Poproś o nowy na stronie logowania.",
  reset_failed: "Ten link jest nieprawidłowy lub wygasł. Poproś o nowy.",
  admin_tab_device_types: "Typy urządzeń",
  admin_dt_title: "Typy urządzeń",
  admin_dt_sub: "Katalog modeli urządzeń. Zmień wyświetlaną nazwę typu — klucz wewnętrzny, mapowanie IoT i synchronizacja się nie zmieniają.",
  admin_dt_col_label: "Wyświetlana nazwa",
  admin_dt_col_key: "Klucz wewnętrzny",
  admin_dt_col_category: "Kategoria",
  admin_dt_col_wearable: "Noszone",
  admin_dt_col_ble_sync: "Synchronizacja BLE",
  admin_dt_col_ble_type_id: "ID typu BLE",
  admin_dt_wearable_yes: "Noszone przez mieszkańca",
  admin_dt_wearable_no: "Stacjonarne",
  admin_dt_ble_sync_on: "Wymagana",
  admin_dt_ble_sync_off: "Wyłączona",
  admin_dt_edit_label: "Edytuj nazwę",
  admin_dt_edit_title: "Zmień wyświetlaną nazwę",
  admin_dt_edit_desc: "Zmienia się tylko czytelna nazwa. Urządzenia, filtry i integracje nadal używają klucza wewnętrznego „{key}”.",
  admin_dt_label_saved: "Nazwa zaktualizowana.",
  admin_dt_label_required: "Nazwa nie może być pusta.",
  admin_dt_load_failed: "Wczytywanie typów urządzeń",
  admin_dt_save_failed: "Aktualizacja nazwy",
  admin_dt_readonly_hint: "Tylko superadministratorzy mogą zmieniać nazwy typów.",
  sensor_climate: "Klimat",
  sensor_temperature: "Temperatura",
  sensor_humidity: "Wilgotność",
  sensor_last_reading: "Ostatni odczyt",
  sensor_history_title: "Temperatura i wilgotność (48 h)",
  sensor_history_empty_title: "Brak odczytów",
  sensor_history_empty_sub: "Przypisz czujnik H4 Pro do tego pokoju, aby zobaczyć historię klimatu.",
  admin_thresholds_title: "Progi czujników",
  admin_thresholds_desc: "Granice alertów temperatury i wilgotności dla czujników H4 Pro w tej organizacji.",
  admin_thresholds_temp_min: "Min. temperatura",
  admin_thresholds_temp_max: "Maks. temperatura",
  admin_thresholds_hum_min: "Min. wilgotność",
  admin_thresholds_hum_max: "Maks. wilgotność",
  admin_thresholds_temp_invalid: "Min. temperatura musi być niższa od maks.",
  admin_thresholds_hum_invalid: "Min. wilgotność musi być niższa od maks.",
  admin_thresholds_hint: "Wszystkie cztery są opcjonalne — zostaw pole puste, aby nie alarmować dla tej granicy.",
  admin_thresholds_cooldown: "Przerwa między alertami",
  admin_thresholds_cooldown_placeholder: "Domyślnie: 30 min",
  admin_thresholds_cooldown_help: "Minuty między powtarzanymi alertami czujnika. Zostaw puste dla wartości systemowej (30 min).",
  admin_thresholds_cooldown_invalid: "Przerwa musi być liczbą całkowitą, co najmniej 1 minutą.",
  admin_thresholds_saved: "Progi zapisane.",
  admin_thresholds_load_failed: "Wczytywanie progów",
  admin_thresholds_save_failed: "Zapisywanie progów",
  room_activity_view_all: "Zobacz wszystkie zdarzenia",
  role_super_admin: "Superadministrator",
  assign_device: "Przypisz urządzenie",
  select_device: "Wybierz urządzenie…",
  admin_patient_no_devices_assigned: "Brak przypisanych urządzeń.",
  admin_patient_no_wearables: "Brak dostępnych urządzeń noszonych w tej organizacji.",
  admin_patient_device_reassign: "przypisz ponownie",
  recent_critical_alerts_title: "Ostatnie alerty krytyczne",
  rooms_building_clear: "Wyczyść filtr",
  buildings_title: "Budynki",
  buildings_sub: "Każdy nadzorowany budynek wraz z pokojami, mieszkańcami i urządzeniami.",
  buildings_view_rooms: "Zobacz pokoje",
  wt_title: "Trend tygodniowy",
  wt_desc: "Siedem nocy obok siebie dla każdego mieszkańca — lub wspólnego pokoju — aby wychwycić noce niespokojne lub nietypowo spokojne.",
  wt_baseline_note: "każda noc porównywana z medianą 7 nocy wiersza",
  wt_no_sensors: "Żaden mieszkaniec nie ma jeszcze czujnika ruchu.",
  wt_flag_restless: "Niespokojna",
  wt_flag_still: "Nietypowo spokojna",
  wt_flag_nodata: "Brak danych",
  wt_flag_silent: "Czujnik prawie milczy",
  rep_sensor_silent: "Czujnik raportował tylko przez {pct}% tej nocy. Przerwy oznaczają, że czujnik przestał raportować, a nie że mieszkaniec był nieruchomy.",
  wt_legend_active: "Aktywne okna 5 min",
  wt_legend_still: "Najdłuższy bezruch (h)",
  fap_title: "Rodzina może obsługiwać alerty",
  fap_desc: "Po włączeniu członkowie rodziny mogą potwierdzać, rozwiązywać, ponownie otwierać i komentować alerty swoich podopiecznych w {org}.",
  note_saved: "Notatka zapisana",
  event_device_silent: "Czujnik milczy",
  event_no_movement: "Brak ruchu",
  event_no_rise: "Brak ruchu po nocy",

  dur_lt_min: "mniej niż minutę",
  dur_min: "{m} min",
  dur_h: "{h} godz.",
  dur_h_min: "{h} godz. {m} min",
  am_fall: "Wykryto upadek",
  am_sos: "Naciśnięto przycisk SOS",
  am_low_battery: "Niski poziom baterii urządzenia",
  am_low_battery_dev: "Niski poziom baterii: {device}",
  am_door: "Drzwi otwarte",
  am_door_in: "Drzwi otwarte: {place}",
  am_door_in_detail: "Drzwi otwarte: {place} ({detail})",
  am_window: "Okno otwarte",
  am_window_in: "Okno otwarte: {place}",
  am_window_in_detail: "Okno otwarte: {place} ({detail})",
  am_silent: "Czujnik ruchu w {place} nie przesyła danych od około {dur} — sprawdź zasilanie lub bramkę",
  am_silent_nodur: "Czujnik ruchu w {place} przestał przesyłać dane — sprawdź zasilanie lub bramkę",
  am_nomove: "Nie wykryto ruchu w {place} od około {dur}",
  am_nomove_nodur: "Nie wykryto ruchu w {place}",
  am_norise: "Nie wykryto ruchu w {place} od końca nocy (zwykle wstaje do {time})",
  am_norise_notime: "Nie wykryto ruchu w {place} od końca nocy",
  amf_silent_res: "Czujnik ruchu {name} nie przesyła danych od {time}, więc ruch nie jest teraz śledzony.",
  amf_silent_room: "Czujnik ruchu w {place} nie przesyła danych od {time}, więc ruch nie jest tam teraz śledzony.",
  amf_sensor_ok: "Czujnik działa; po prostu nie widział, żeby ktoś się poruszał.",
  amf_team: "Zespół opieki został powiadomiony na swoim pulpicie.",
  amf_contact_device: "Jesteś osobą kontaktową dla tego urządzenia.",
  amf_contact_resident: "Jesteś osobą kontaktową dla: {name}.",
  al_tab_care: "Opieka",
  al_tab_maint: "Serwis",
  al_maint_hint: "Czujniki, które przestały przesyłać dane, i słabe baterie: praca techniczna, nie zdarzenia opiekuńcze.",
  al_maint_empty: "Brak problemów z czujnikami i bateriami.",
  al_auto_closed: "Zamknięty automatycznie",
  al_auto_closed_reason: "Zamknięty automatycznie — {reason}",
  al_never_seen: "nikt go nie widział przed zamknięciem",
  al_resolved_by: "Rozwiązał(a) {name}",
  al_reason_movement: "ruch został wznowiony",
  al_reason_sensor: "czujnik znów przesyła dane",
  al_admin_only_ack: "Tylko administrator może obsłużyć ten alert, bo nie jest powiązany z jednym podopiecznym.",
  why_title: "Dlaczego to się uruchomiło?",
  why_since_motion: "Od ostatniego ruchu",
  why_since_sample: "Od ostatnich danych z czujnika",
  why_threshold: "Próg",
  why_up_by: "Zwykle wstaje do",
  why_night: "Okno nocne",
  why_source: "Próg ustalony przez",
  why_src_org: "tę organizację",
  why_src_default: "wartości domyślne",
  why_state: "Stan czujnika",
  why_checked: "Sprawdzono o",
  why_approx: "Kontrole odbywają się co 5 minut, więc godziny alertów są przybliżone.",
  mon_label: "Monitorowanie ruchu",
  mon_active: "aktywne",
  mon_down: "brak danych",
  mon_down_since: "brak danych od {time}",
  admin_alerts_up_by_label: "Zwykle wstaje do",
  admin_alerts_up_by_question: "Jeśli między końcem nocy a tą godziną nie widać ruchu, tworzony jest alert „brak ruchu od końca nocy”.",
  admin_alerts_up_by_invalid: "Musi być później niż koniec nocy ({end}): to godzina, o której podopieczni zwykle już wstali, po nocy.",
  admin_alerts_up_by_format: "Wpisz godzinę jako HH:MM.",
  admin_alerts_escalation_label: "Powiadom rodzinę o milczącym czujniku po",
  admin_alerts_escalation_question: "Personel widzi milczący czujnik od razu. Rodzina jest powiadamiana tylko, jeśli po tym czasie nadal nie jest rozwiązany (od razu, jeśli organizacja nie ma opiekunów).",
  admin_alerts_cooldown_note: "Po zamknięciu alertu ten sam alert może wrócić, gdy próg zostanie ponownie przekroczony. Poranny alert uruchamia się najwyżej raz dziennie.",
  admin_alerts_stored_invalid: "Zapisana godzina ({up}) nie jest po końcu nocy ({end}), więc poranne alerty nie mogą działać, a tej polityki nie da się zapisać, dopóki tego nie poprawisz.",
  admin_alerts_defaults_badge: "Wartości domyślne",

  fap_auto_on: "Automatycznie: włączone, bo ta organizacja nie ma opiekunów.",
  fap_auto_off: "Automatycznie: wyłączone, bo ta organizacja ma opiekunów.",
  fap_manual: "Ustawione przez administratora.",
  fap_reset: "Przywróć automatyczne",
  fap_saved: "Zapisano",
  fap_save_failed: "Nie udało się zapisać. Spróbuj ponownie.",
  fap_pending: "Wkrótce",
  fap_retry: "Spróbuj ponownie",
  recap_title: "Poranne podsumowanie nocy",
  recap_desc_staff: "Codziennie o 07:00 (czasu organizacji) podsumowanie nocy każdego mieszkańca Twojej organizacji.",
  recap_desc_family: "Codziennie o 07:00 (czasu organizacji) podsumowanie nocy Twoich bliskich.",
  recap_on: "Włączone",
  recap_off: "Wyłączone",
  recap_email: "E-mail",
  recap_telegram_link_first: "Połącz Telegram powyżej, aby otrzymywać je tam.",
  recap_no_channel: "Wybierz co najmniej jeden kanał, inaczej nic nie zostanie wysłane.",
  recap_last_sent: "Ostatnio wysłano {at}",
  recap_saved: "Preferencje zapisane.",
  recap_save_failed: "Nie udało się zapisać preferencji.",
  recap_unavailable: "Wkrótce",
  topbar_org_label: "Organizacja",
  device_ota_phase2: "Wdrażanie OTA stanie się interaktywne w fazie 2.",
  event_window_open: "Okno otwarte",
  event_window_close: "Okno zamknięte",
  event_alarm_end: "Koniec alarmu",
  wt_h: "h",
  wt_load_failed: "Nie udało się wczytać historii ruchu. Spróbuj później.",
  recap_load_failed: "Nie udało się wczytać preferencji — dotknij, aby ponowić.",
  mv_shared_note: "Ten mieszkaniec dzieli pokój. Czujnik pokojowy nie rozróżnia mieszkańców, więc ruch jest pokazywany dla pokoju, a nie dla jednej osoby.",
  mv_shared_link: "Zobacz ruch: {room}",
  mv_room_shared_note: "Wspólny dla {n} mieszkańców — tego ruchu nie można przypisać żadnemu z nich.",
  rep_shared_room_row: "Wspólny pokój · {names}",
  admin_motion_resident: "Czujnik przy łóżku mieszkańca",
  admin_motion_resident_hint: "Opcjonalne. Wybierz mieszkańca tylko, jeśli czujnik obserwuje jego przestrzeń (np. skierowany na łóżko). Jego wykresy ruchu będą go używać, nawet we wspólnym pokoju.",
  admin_motion_whole_room: "Cały pokój",
};
export default pl;
